import { Text, View } from "react-native";
import { TouchableRipple } from "react-native-paper";
import { ScreenContainer, ScrollableContainer } from "../../components";
import PdrHistoryData from "./PdrHistoryData";
import ReportPdr from "./ReportPdr";
import { ScreenProps } from "../types";

function PaneToggle({
  panes,
  selected,
  select,
}: {
  selected: string;
  panes: { id: string; slug: string; name: string; disabled?: boolean }[];
  select(pane: { slug: string }): void;
}) {
  return (
    <View className={`items-start px-6 py-6 md:py-4 md:mt-7 md:mb-2`}>
      <View className="flex-row rounded-lg bg-sky-lighter justify-center items-center mx-auto">
        {panes.map((pane) => (
          <TouchableRipple
            key={pane.id}
            testID="pane-toggle"
            onPress={() => select(pane)}
            disabled={pane.disabled}
            className={`rounded-lg py-2 px-4 border items-center ${
              selected === pane.slug ? "border-primary-light bg-sky-white" : "border-sky-lighter bg-transparent"
            } ${pane.disabled ? "bg-sky-lightest" : ""}`}
          >
            <Text
              className={`${
                selected === pane.slug ? "font-500 text-primary-light" : "font-400 text-ink-light"
              } text-small-tight`}
            >
              {pane.name}
            </Text>
          </TouchableRipple>
        ))}
      </View>
    </View>
  );
}

export default function PdrHistoryScreen({ route, navigation }: ScreenProps<"PdrHistory">) {
  const { slug } = route.params;

  const selectPane = (pane: { slug: string }) => {
    navigation.navigate("PdrHistory", { slug: pane.slug });
  };

  return (
    <ScreenContainer testID="pdrHistoryScreen" navigationTitle="PDR History" goBack={() => {}}>
      <ScrollableContainer>
        <View>
          <PaneToggle
            panes={[
              { id: "reportPDRs", slug: "report-pdr", name: "Report PDRs" },
              { id: "pdrHistory", slug: "pdr-history", name: "PDR History" },
            ]}
            selected={slug}
            select={selectPane}
          />
          {slug === "pdr-history" ? <PdrHistoryData /> : <ReportPdr />}
        </View>
      </ScrollableContainer>
    </ScreenContainer>
  );
}
